// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"Users_tabsContainer__iEAyd","tab":"Users_tab__2Nx86","tabActive":"Users_tabActive__2vM0q","userCounter":"Users_userCounter__1fjIj"};